<template>
  <iframe
    class="vimeo-video"
    :src="videoUrl"
  ></iframe>
</template>

<script>
import UrlParse from 'url-parse'

export default {
  components: {
  },
  props: {
    src: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  },
  computed: {
    videoUrl () {
      const url = UrlParse(this.src, true)
      console.log(url)
      let id = ''
      if (url.hostname.indexOf('player.vimeo.com') >= 0) {
        // https://player.vimeo.com/video/259411563
        id = url.pathname.split('/')
        console.log(id)
        if (id.length > 3) id = id[3]
      } else {
        // https://vimeo.com/259411563
        id = url.pathname.split('/')
        console.log(id)
        if (id.length > 1) id = id[1]
      }
      return 'https://player.vimeo.com/video/' + id
    }
  },
  methods: {
  }
}
</script>

<style lang="stylus">
// @import '../../assets/css/base.styl'

.vimeo-video

    .player
        width 100% !important
</style>



// WEBPACK FOOTER //
// src/components/commons/videos/VimeoVideo.vue